import { Divider, Group, Text } from "@mantine/core";
import DarkModeToggle from "../header/DarkModeToggle";
import Logo from "../logos/tiber/Logo";
import LogoText from "../logos/tiber/LogoText";
import ContactModule from "./components/ContactModule";
import { default as FooterNavLinks } from "./components/FooterNavLinks";
import SocialLinks from "./components/SocialLinks";
import classes from "./Footer.module.css";

export default function Footer({
  liveSubjectNames,
}: {
  liveSubjectNames: string[];
}) {
  return (
    <footer className={classes.footer}>
      <div className={classes.topWrapper}>
        <Group gap={"xs"} className={classes.logoWrapper}>
          <Logo size={30} color="white" />
          <LogoText c="white" />
        </Group>
        <ContactModule type={"contact"} />
        <ContactModule type={"feedback"} />
      </div>
      <FooterNavLinks liveSubjectNames={liveSubjectNames} />
      <Divider color="white" className={classes.fullWidth} />
      <Text c="darkgrey" size="xs" className={classes.legalWrapper}>
        © {new Date().getFullYear()} Tiber Tutor. All rights reserved
      </Text>
      <div className={classes.socialWrapper}>
        <DarkModeToggle />
        <SocialLinks />
      </div>
    </footer>
  );
}

export const useFooterStyles = () => ({ classes });
